<template>
  <drag-dialog
    :title="`${clientInfo ? '编辑' : '新增'}Client`"
    :width="600"
    :visible.sync="visible"
    :footerBtn="['cancel', 'submit']"
    :defaultTop="150"
    :defaultLeft="620"
    :submit="submit"
    :cancel="cancel"
  >
    <el-form
      class="form public-form-primary"
      :model="form"
      :rules="rules"
      label-width="100px"
      ref="form"
    >
      <el-form-item label="ClientId:" prop="clientId">
        <el-input class="input-primary" v-model="form.clientId" placeholder="请输入ClientId">
        </el-input>
      </el-form-item>
      <el-form-item label="范围:" prop="scopes">
        <el-select class="primary-select" :popper-append-to-body="false" multiple size="small" v-model="form.scopes">
          <el-option
            v-for="(item, index) in scopesList"
            :key="index"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="描述:">
        <el-input
        class="input-primary"
          v-model="form.description"
          autocomplete="off"
          placeholder="请输入Client描述"
          type="textarea"
          maxlength="200"
          rows="5"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>
  </drag-dialog>
</template>
  
<script>
import dragDialog from "@/components/DragDialog.vue";

import { createClient, updateClient } from "@/service/interface";

export default {
  data() {
    return {
      form: {
        id: "",
        clientId: "",
        scopes: [],
        description: "",
      },
      scopesList: [
        { label: "基础数据", value: "Base" },
        { label: "项目管理", value: "Project" },
        { label: "资源发布", value: "Resource" },
      ],
      rules: {
        clientId: [
          {
            required: true,
            message: "请输入ClientId",
            trigger: "blur",
          },
          {
            pattern: /^[a-zA-Z0-9_-]+$/,
            message: "ClientId只能包含英文、数字、下划线、中划线",
            trigger: "blur",
          },
        ],
        scopes: [
          {
            required: true,
            message: "范围不能为空",
            trigger: "blur",
          },
        ],
      },
    };
  },
  props: {
    visible: Boolean,
    clientInfo: Object,
    closeDialog: Function,
    queryClientList: Function,
  },
  components: {
    dragDialog,
  },
  watch: {
    clientInfo: function (newValue) {
      if (newValue) {
        this.form = {
          id: newValue.id,
          clientId: newValue.clientId,
          scopes: JSON.parse(newValue.scopes),
          description: newValue.description,
        };
      } else {
        this.form = {
          id: "",
          clientId: "",
          scopes: [],
          description: "",
        };
      }
    },
  },
  methods: {
    submit() {
      this.$refs.form.validate((bool, object) => {
        if (bool) {
          if (!this.clientInfo) {
            createClient(this.form).then((response) => {
              if (response.status === 200) {
                let data = response.data;
                if (data.isSuccess) {
                  this.queryClientList().then(() => {
                    this.$message.success("新建Client成功！！！");

                    this.cancel();
                  });
                } else {
                  this.$message.error(data.errMsg);
                }
              }
            });
          } else {
            updateClient(this.form).then((response) => {
              if (response.status === 200) {
                this.queryClientList().then(() => {
                  this.$message.success("修改成功！！！");

                  this.cancel();
                });
              }
            });
          }
        } else {
          this.$message.error("表单验证失败，请正确填写相关内容后再重新提交");
        }
      });
    },
    cancel() {
      this.form = {
        id: "",
        clientId: "",
        scopes: [],
        description: "",
      };
      this.closeDialog();
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/css/publishSearch.less";
.form{
  :deep(.el-form-item){
    margin-bottom: 18px;
    .el-select{
      width: 100%;
    }
    .el-input__inner{
      height: 32px;
    }
  }
}
</style>